export default {
    donate: "https://secure.actblue.com/donate/akiva-us",
    podcast: "/podcast",
    store: "https://akiva.store",
    home: "/",
    platform: "/platfrom",
    what: "/what-the-heck",
    signup: "/signup",
    episode: (slug: string) => `/podcast/${slug}`
}